
import Vue from "vue";
import Component from 'vue-class-component';
import api from '../service/api';
import { getModule } from "vuex-module-decorators";
import UserModule from "@/store/modules/User";
import store from "@/store";
import PasswordChangedDialog from "./PasswordChangedDialog.vue";

const userModule = getModule(UserModule, store);

@Component({
    components: {
        PasswordChangedDialog
    },
})
export default class AccountSettings extends Vue {
    public changeAccountPassword = false;
    public oldPassword: string = '';
    public newPassword: string = '';
    public repeatNewPassword: string = '';
    public passwordChanged = false;
    public oldPasswordErrors: string[] = [];

    public oldPasswordRules = [
        (v: string) => !!v || 'Hasło jest wymagane'
    ];
    public newPasswordRules = [
        (v: string) => !!v || 'Hasło jest wymagane',
        (v: string) => /((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{6,}))|((?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{8,}))/.exec(v) || 'Hasło jest za słabe',
    ];
    get repeatNewPasswordRules() {
        return [
            (v: string) => !!v || 'Hasło jest wymagane',
            (v: string) => v === this.newPassword || 'Hasła muszą być identyczne',
        ];
    }

    async changePassword() {
        const resp = await api.changePassword(this.oldPassword, this.newPassword);
        if (!resp) {
            this.passwordChanged = true;
            await new Promise(resolve => setTimeout(resolve, 5000));
            await userModule.logout();
        } else if (resp.error && resp.error === 'Invalid password') {
            this.oldPasswordErrors = ['Hasło niepoprawne'];
        }
    }
}
